const medicationChecklistItems = [
  'Not taking any medications',
  'Currently taking steroids',
  'Currently taking immunosuppressants',
  'Currently injecting insulin',
  'Currently undergoing hormone replacement therapy',
  'Currently taking painkillers',
  'Currently taking sedatives/psychotropic medications',
  'Currently taking weight loss medication',
];

export default medicationChecklistItems;
